import {
    AdSlotAnchorLeaderboardState,
    initialAdSlotAnchorLeaderboardState,
} from "@/mk2/containers/AdSlotAnchorLeaderboard/AdSlotAnchorLeaderboard.reducers";
import { AppState } from "@/mk2/reducers";

export const getAdSlotAnchorLeaderboardState = (state: AppState): AdSlotAnchorLeaderboardState =>
    state.containers.global.adSlotAnchorLeaderboard || initialAdSlotAnchorLeaderboardState;
